import { environmentConfig } from "@src/appV2/environment";
import axios from "axios";

interface ReadBranchDeepLinkResponse {
  data: {
    $deeplink_path: string;
  };
}

export async function readBranchDeepLink({ url }: { url: string }) {
  const response = await axios.get<ReadBranchDeepLinkResponse>(
    environmentConfig.REACT_APP_BRANCH_API_BASE_URL,
    {
      params: {
        url,
        branch_key: environmentConfig.REACT_APP_BRANCH_API_KEY,
      },
    }
  );

  if (response.status !== 200) {
    throw new Error(`Failed to read branch deep link: ${JSON.stringify(response.data)}`);
  }

  return response.data;
}
